import React, { useState } from 'react';
import {
  Box,
  VStack,
  Heading,
  Text,
  Input,
  Button,
  FormControl,
  FormLabel,
  FormHelperText,
  Alert,
  AlertIcon,
  AlertDescription,
  Spinner,
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';

function SearchForm({ onSearch, loading, error }) {
  const [domain, setDomain] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (domain.trim()) {
      onSearch(domain.trim());
    }
  };

  return (
    <VStack spacing={8} align="stretch" maxW="700px" mx="auto" pt={12}>
      {/* Header */}
      <Box textAlign="center" mb={4}>
        <Heading
          as="h1"
          fontSize="4xl"
          fontWeight="bold"
          color="white"
          mb={2}
        >
          DNS Detection Tool
        </Heading>
        <Text fontSize="md" color="gray.400" fontWeight="medium">
          Internal Tool - Ferocious Media
        </Text>
      </Box>

      {/* Error Alert */}
      {error && (
        <Alert
          status="error"
          borderRadius="md"
          bg="red.900"
          borderColor="red.700"
          borderWidth="1px"
        >
          <AlertIcon />
          <AlertDescription color="white">{error}</AlertDescription>
        </Alert>
      )}

      {/* Loading State */}
      {loading && (
        <Box textAlign="center" py={16}>
          <Spinner
            thickness="3px"
            speed="0.65s"
            emptyColor="gray.700"
            color="brand.500"
            size="xl"
            mb={4}
          />
          <Text color="gray.400" fontSize="sm">Querying WHOIS data...</Text>
        </Box>
      )}

      {/* Search Form */}
      {!loading && (
        <Box
          bg="#1A1F2E"
          p={10}
          borderRadius="lg"
          boxShadow="2xl"
          borderWidth="1px"
          borderColor="gray.700"
        >
          <form onSubmit={handleSubmit}>
            <VStack spacing={6}>
              <FormControl>
                <FormLabel fontSize="sm" fontWeight="semibold" color="white" mb={3}>
                  Domain Name
                </FormLabel>
                <Input
                  size="lg"
                  value={domain}
                  onChange={(e) => setDomain(e.target.value)}
                  placeholder="example.com"
                  bg="#0F1419"
                  borderColor="gray.600"
                  color="white"
                  _placeholder={{ color: 'gray.500' }}
                  _hover={{ borderColor: 'gray.500' }}
                  _focus={{
                    borderColor: 'brand.500',
                    boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)',
                  }}
                  fontSize="md"
                  autoFocus
                />
                <FormHelperText color="gray.500" fontSize="xs" mt={2}>
                  Enter a domain name without http:// or www
                </FormHelperText>
              </FormControl>

              <Button
                type="submit"
                size="lg"
                width="full"
                leftIcon={<SearchIcon />}
                isDisabled={!domain.trim()}
                bg="brand.500"
                color="white"
                _hover={{
                  bg: 'brand.600',
                  transform: 'translateY(-1px)',
                  boxShadow: 'lg',
                }}
                _active={{
                  transform: 'translateY(0)',
                }}
                fontWeight="semibold"
              >
                Check DNS
              </Button>
            </VStack>
          </form>
        </Box>
      )}
    </VStack>
  );
}

export default SearchForm;
